/**
 * @typedef {Object} Tab
 * @property {HTMLElement} toggle
 * @property {HTMLElement} target
 */

export class Tabs {
	selectors = {
		toggleSelector: '.js-tab',
	};

	tabs = [];

	constructor() {
		[...document.querySelectorAll(this.selectors.toggleSelector)].forEach((toggle) => {
			/**
			 * @type {Tab}
			 */
			const tab = {
				toggle: toggle,
				target: this.findTarget(toggle),
			};

			this.bindTabClick(tab);

			// pre-open if is-active is set
			if (tab.toggle.classList.contains('is-active')) {
				this.openTab(tab);
			}

			this.tabs.push(tab);
		});
	}

	/**
	 * @param {Tab} tab
	 */
	bindTabClick(tab) {
		tab.toggle.addEventListener('click', (event) => {
			event.preventDefault();
			this.toggleTab(tab);
		});
	}

	/**
	 * @param {HTMLElement} toggle
	 * @returns {HTMLElement}
	 */
	findTarget(toggle) {
		let target;

		if (toggle.hasAttribute('data-target')) {
			target = toggle.getAttribute('data-target');
		} else if (toggle.hasAttribute('href')) {
			target = toggle.getAttribute('href');
		}

		if (!target) {
			throw new Error(`No target found for toggle: ${toggle}`);
		}

		return document.querySelector(target);
	}

	/**
	 * @param {Tab} tab
	 */
	toggleTab(tab) {
		const isActive = tab.toggle.classList.contains('is-active');

		if (isActive) {
			this.closeTab(tab);
		} else {
			this.openTab(tab);
		}
	}

	/**
	 * @param {Tab} tab
	 */
	openTab(tab) {
		// collapse all tabs
		this.tabs.forEach((x) => this.closeTab(x));

		// open this tab
		tab.toggle.classList.add('is-active');
		tab.target.classList.add('is-active');

		// handle bound inputs
		let input = tab.toggle.dataset.input;
		let inputEl = document.querySelector('input[name="' + input + '"]');
		if (inputEl && tab.toggle.dataset.value) {
			inputEl.value = tab.toggle.dataset.value;
		}
	}

	/**
	 * @param {Tab} tab
	 */
	closeTab(tab) {
		tab.toggle.classList.remove('is-active');
		tab.target.classList.remove('is-active');
	}
}

window.tkTabs = new Tabs();
